import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { IconButton, InputPicker, Panel, Text } from 'rsuite';
import { MdOutlineSettings as IconSettings } from 'react-icons/md';

import {
  coloursAstral,
  coloursAquaQuip,
  coloursAquaQuipInstaTouch,
  coloursAquatight,
  coloursAquatightSupa,
  coloursJandy,
  coloursLEDPro,
  coloursModLite,
  coloursSingleColour,
  coloursSpaElectrics,
  coloursSpaElectricsMultiPlus,
  coloursWaterCo,
  lightBrandOptionsSelect,
  light_brand_t,
  coloursPentair,
} from '../constants';
import { REGS } from '../registers';
import { DisplayIcon } from './DisplayIcon';

export const DisplayLightSettingsNonPaneled = ({
  register,
  tc = /** @type {any} */ (undefined),
  icon,
  onChange,
  lightNumber,
  disabled,
  ignoreBrand = false,
}) => {
  const [brandValue, setBrandValue] = useState(/** @type {number | null} */ (null));
  const [colourValue, setColourValue] = useState(/** @type {number | null} */ (null));

  const updateBrandValue = (value, event) => {
    setBrandValue(value);
    var newValue = (value << 8) | (colourValue ?? 0);
    onChange(register, newValue, true);
  };

  const updateColourValue = (value, event) => {
    setColourValue(value);
    var newValue = ((brandValue ?? 0) << 8) | value;
    onChange(register, newValue);
  };

  const updateBrightnessSetting = (value, event) => {
    var newValue = 2;

    var the_brightness_register = REGS.LIGHT_1_REINIT;
    if (lightNumber === 1) {
      the_brightness_register = REGS.LIGHT_1_REINIT;
    } else if (lightNumber === 2) {
      the_brightness_register = REGS.LIGHT_2_REINIT;
    } else if (lightNumber === 3) {
      the_brightness_register = REGS.LIGHT_3_REINIT;
    }
    onChange(the_brightness_register, newValue, true);
  };
  const isBrightnessAdjustable = () => {
    var brightNessAdjustbale = false;
    switch (brandValue) {
      case light_brand_t.SINGLE_COLOUR:
        break;
      case light_brand_t.AQUAQUIP_INSTATOUCH:
        break;
      case light_brand_t.AQUAQUIP:
        break;
      case light_brand_t.AQUATIGHT:
        break;
      case light_brand_t.AQUATIGHT_SUPA:
        break;
      case light_brand_t.ASTRAL:
        break;
      case light_brand_t.JANDY:
        break;
      case light_brand_t.LED_PRO:
        break;
      case light_brand_t.SPA_ELECTRICS:
        break;
      case light_brand_t.SPA_ELECTRICS_MULTIPLUS:
        brightNessAdjustbale = true;
        break;
      case light_brand_t.MODLITE:
        break;
      case light_brand_t.WATERCO:
        break;
      default:
        break;
    }
    return brightNessAdjustbale;
  };

  const getCurrentColours = () => {
    var culors = [{ value: 0, label: 'None' }];
    switch (brandValue) {
      case light_brand_t.SINGLE_COLOUR:
        culors = coloursSingleColour;
        break;
      case light_brand_t.AQUAQUIP_INSTATOUCH:
        culors = coloursAquaQuipInstaTouch;
        break;
      case light_brand_t.AQUAQUIP:
        culors = coloursAquaQuip;
        break;
      case light_brand_t.AQUATIGHT:
        culors = coloursAquatight;
        break;
      case light_brand_t.AQUATIGHT_SUPA:
        culors = coloursAquatightSupa;
        break;
      case light_brand_t.ASTRAL:
        culors = coloursAstral;
        break;
      case light_brand_t.JANDY:
        culors = coloursJandy;
        break;
      case light_brand_t.LED_PRO:
        culors = coloursLEDPro;
        break;
      case light_brand_t.SPA_ELECTRICS:
        culors = coloursSpaElectrics;
        break;
      case light_brand_t.SPA_ELECTRICS_MULTIPLUS:
        culors = coloursSpaElectricsMultiPlus;
        break;
      case light_brand_t.MODLITE:
        culors = coloursModLite;
        break;
      case light_brand_t.WATERCO:
        culors = coloursWaterCo;
        break;
      case light_brand_t.PENTAIR:
        culors = coloursPentair;
        break;
      default:
        break;
    }
    return culors;
  };

  useEffect(() => {
    var brand = (register.value & 0xff00) >> 8;
    setBrandValue(brand);
    var colour = register.value & 0x00ff;
    setColourValue(colour);
  }, [register.value]);

  return (
    <Flex justifyContent="start" className="space-x-4">
      <DisplayIcon icon={icon} />
      {ignoreBrand !== true && (
        <div>
          <Text>Brand:</Text>
          <InputPicker
            block
            cleanable={false}
            searchable={false}
            placement="autoVerticalStart"
            data={lightBrandOptionsSelect}
            value={brandValue}
            disabled={disabled}
            onChange={updateBrandValue}
            style={{ width: 224 }}
          />
        </div>
      )}
      <Text color={tc}>
        <Bold>Colour:</Bold>
      </Text>
      <Flex justifyContent="between" className="space-x-4">
        <InputPicker
          block
          cleanable={false}
          searchable={false}
          placement="autoVerticalStart"
          data={getCurrentColours()}
          value={colourValue}
          disabled={disabled}
          onChange={updateColourValue}
          style={{ width: 224 }}
        />
        {isBrightnessAdjustable() && (
          <IconButton
            appearance="primary"
            color="blue"
            size="sm"
            icon={<IconSettings />}
            onClick={updateBrightnessSetting}
            disabled={disabled}
            aria-label={`Brightness settings for light ${lightNumber}`}
          />
        )}
      </Flex>
    </Flex>
  );
};

export const DisplayLightSettings = ({
  register,
  icon,
  onChange,
  lightNumber = 1,
  disabled,
  ignoreBrand = false,
  borderOff = false,
}) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <DisplayLightSettingsNonPaneled
        register={register}
        icon={icon}
        onChange={onChange}
        lightNumber={lightNumber}
        disabled={disabled}
        ignoreBrand={ignoreBrand}
      ></DisplayLightSettingsNonPaneled>
    </Panel>
  );
};
